import * as React from 'react';
import assign = require('object-assign');
import translate from '../../locale/translate';

import * as WidgetComponents from '../widget';

import { Tag, Widget } from '../../store/models';

interface IProps {
    widget: Widget,
    data: { tags: Tag[] }
    isOpen: boolean,
    onSave: Function,
    onClose: Function
}

export default class WidgetEditor extends React.Component<IProps, any> {
    static propTypes = {
        widget: React.PropTypes.object,
        data: React.PropTypes.object.isRequired,
        isOpen: React.PropTypes.bool,
        onSave: React.PropTypes.func.isRequired,
        onClose: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.componentWillReceiveProps(props)
    }

    componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.widget) {
            this.state = assign({}, nextProps.widget.settings);
        }
    }

    handleChange(name: string, value: any) {
        this.setState(assign({}, this.state, { [name]: value }));
    }

    handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        const { widget, onSave } = this.props;

        event.preventDefault();
        onSave(widget.id, this.state);
    }

    render() {
        const { widget, isOpen, onClose } = this.props;

        if (!isOpen || !widget) {
            return (<div />);
        }

        return (
            <form onSubmit={this.handleSubmit}>
                {this.renderEditor(widget)}

                <button type="submit" className="btn btn-primary" value="">{translate.gettext("Apply")}</button>
                <button type="button" className="btn btn-default pull-right" onClick={() => onClose()}>{translate.gettext("Cancel")}</button>
            </form>
        );
    }

    renderEditor(widget: Widget) {
        const WidgetComponent = WidgetComponents.getByName(widget.type);

        if (WidgetComponent && WidgetComponent.Editor) {
            return <WidgetComponent.Editor
                settings={this.state}
                data={this.props.data}
                handleChange={this.handleChange.bind(this)}
                />;
        } else {
            console.warn(`${widget.type} is an unknown widget type or has no Editor`);
        }

        return (<div>{translate.gettext("No editor available")}</div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/widgetEditor/WidgetEditor.tsx